import { createContext, useContext, useState, useEffect } from "react";
import { fetchEvents } from "../api/apis";
import { getTeams } from "../api/teams";

const GlobalContext = createContext();

async function GetEvents() {
  const data = await fetchEvents(2025);
  return data;
}

async function GetTeams() {
  const data = await getTeams();
  return data;
}

export const GlobalProvider = ({ children }) => {
  const [teamList, setTeamList] = useState([]);
  const [eventList, setEventList] = useState([]);
  const [targetAnalysisPage, setTargetAnalysisPage] = useState("overview");
  const [recentPages, setRecentPages] = useState([]);
  const [currentTab, setCurrentTab] = useState("");

  useEffect(() => {
    const fetchEventData = async () => {
      const result = await GetEvents();
      try {
        setEventList(result);
        console.log(result);
      } catch (error) {
        console.error("Error parsing event data:", error);
        setEventList([]);
      }
    };

    fetchEventData();

    const fetchRobotData = async () => {
      const result = await GetTeams();
      try {
        const parsedData = JSON.parse(result?.body);
        setTeamList(Array.isArray(parsedData?.data) ? parsedData.data : []);
        console.log(Array.isArray(parsedData?.data) ? parsedData.data : []);
      } catch (error) {
        console.error("Error parsing team data:", error);
        setTeamList([]);
      }
    };

    fetchRobotData();
  }, []);

  useEffect(() => {
    const storedPages = JSON.parse(localStorage.getItem("recentPages")) || [];
    setRecentPages(storedPages);
  }, []);

  const addPage = (pageName) => {
    setRecentPages((prev) => {
      let updatedPages = prev.filter((p) => p !== pageName);
      updatedPages.unshift(pageName);
      updatedPages = updatedPages.slice(0, 12);
      localStorage.setItem("recentPages", JSON.stringify(updatedPages));
      return updatedPages;
    });
  };

  return (
    <GlobalContext.Provider
      value={{
        teamList,
        eventList,
        targetAnalysisPage,
        setTargetAnalysisPage,
        recentPages,
        addPage,
        currentTab,
        setCurrentTab,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobal = () => useContext(GlobalContext);
